// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import SimpleQuoteFormState, {
    SimpleQuoteFormFieldValues,
} from "@store/Framework/Store/Greif/Components/SimpleQuoteForm/SimpleQuoteFormState";
import { Draft } from "immer";

const initialFormFieldValues: SimpleQuoteFormState["formFieldValues"] = {
    estimatedAnnualQuantity: { value: "" },
    attachments: { value: [] },
    emailAddress: { value: "" },
    firstName: { value: "" },
    lastName: { value: "" },
    requestDetails: { value: "" },
    phoneNumber: { value: "" },
    productType: { value: "" },
    referenceProductId: { value: "" },
    shipToNumber: { value: "" },
};

const initialState: SimpleQuoteFormState = {
    formFieldValues: initialFormFieldValues,
    formDraftFieldValues: initialFormFieldValues,
    isDirty: false,
};

const actions = {
    "Greif/Components/SimpleQuoteForm/SetDraftFieldValues": (
        draft: Draft<SimpleQuoteFormState>,
        action: { parameter: SimpleQuoteFormFieldValues },
    ) => {
        draft.formDraftFieldValues = { ...draft.formDraftFieldValues, ...action.parameter };
    },
    "Greif/Components/SimpleQuoteForm/SaveDraftFieldValues": (
        draft: Draft<SimpleQuoteFormState>,
        action: { keys?: Array<keyof SimpleQuoteFormFieldValues> },
    ) => {
        const draftFieldValues = action.keys?.length
            ? action.keys.reduce((result, key) => ({ ...result, [key]: draft.formDraftFieldValues[key] }), {})
            : draft.formDraftFieldValues;

        draft.formFieldValues = { ...draft.formFieldValues, ...draftFieldValues };
        draft.isDirty = true;
    },
    "Greif/Components/SimpleQuoteForm/CancelDraftFieldValues": (
        draft: Draft<SimpleQuoteFormState>,
        action: { keys?: Array<keyof SimpleQuoteFormFieldValues> },
    ) => {
        const savedFieldValues = action.keys?.length
            ? action.keys.reduce((result, key) => ({ ...result, [key]: draft.formFieldValues[key] }), {})
            : draft.formFieldValues;

        draft.formDraftFieldValues = { ...draft.formDraftFieldValues, ...savedFieldValues };
    },
    "Greif/Components/SimpleQuoteForm/ResetFieldValues": (draft: Draft<SimpleQuoteFormState>) => {
        draft.formFieldValues = initialFormFieldValues;
        draft.formDraftFieldValues = initialFormFieldValues;
        draft.isDirty = false;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifComponentsSimpleQuoteFormActions = Parameters<typeof reducer>[1];
export default reducer;
